// Custom Objects Tour
// Creating custom record types and relating them to contacts
// Selector policy: step 1 pins to the live-verified sidebar id (#sb_settings); teaching steps are
// deliberate centered cards — no guessed element selectors.

export const customObjectsTour = {
  id: 'custom-objects',
  name: 'Custom Objects Tour',
  displayName: 'Model Your Own Data',
  description: 'Creating custom record types and relating them to contacts',
  estimatedDuration: '3 minutes',
  category: 'feature',
  autoStart: false,
  prerequisiteTours: ['ftux'],

  config: { animate: true, overlayOpacity: 0.75, smoothScroll: true, allowClose: true, showProgress: true },

  steps: [
    {
      element: '#sb_settings',
      popover: {
        title: "🧩 Welcome to Custom Objects",
        description: `
          Some things central to your business are not contacts, companies, or deals — properties, vehicles, policies, equipment. **Custom objects** give them their own record type.
        `,
        side: 'right',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🤔 When You Need One",
        description: `
          When you are cramming structured information into notes or a pile of contact fields. If the thing has its own attributes and can relate to several people, it deserves its own object.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🏗️ Design It",
        description: `
          Name it in the **singular**, the way your team says it. Define only the **fields** you will actually use or filter on — over-modelled objects full of empty fields are harder to use than simple ones.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🔗 Relate It",
        description: `
          Decide how it **associates** with contacts and companies. The relationship is where most of the value lives: a policy linked to its holder, a property to its owner.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "⚡ Automate On It",
        description: `
          Once records exist you can filter, report, and automate on them — a renewal reminder driven by a policy expiry date, for example.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🎉 Your Data, Your Shape",
        description: `
          You can now:

✅ Decide when a custom object is warranted
✅ Design it with the minimum useful fields
✅ Associate it with contacts and companies
✅ Automate against it

**Next:** sketch the one object your business keeps needing, then build it small.
        `,
        side: 'over',
        align: 'center',
        showButtons: ['close'],
        doneBtnText: 'Done →'
      }
    }
  ]
};
